/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CompanyFiscalYear } from './CompanyFiscalYear';
export type Company = {
  readonly id?: number;
  firm?: number | null;
  name: string;
  slug?: string;
  legal_company_name?: string | null;
  website?: string | null;
  fiscal_year_end?: CompanyFiscalYear;
  captable_currency?: string;
  financials_currency?: string;
  address?: string | null;
  phone_number?: string | null;
  logo_url?: string | null;
  icon_url?: string | null;
  is_deleted?: boolean | null;
  is_standalone?: boolean;
  podio_id?: number | null;
  type?: Company.type;
  parent_company?: number | null;
  vintage_year?: number | null;
  external_id?: string | null;
  attio_company_id?: string | null;
  file_storage_reference?: string | null;
};
export namespace Company {
  export enum type {
    HOLDING = 'holding',
    PORTFOLIO = 'portfolio',
    STANDALONE = 'standalone',
    INVESTMENT = 'investment',
  }
}
